import { createContext, useContext } from 'react';
import { TeamAthlete, TEAM_ROLE, AthleteTeamMember } from '@type/db-types';
import { StripeAccountContextValues } from '@hooks/useStripeAccount';

export interface TeamContextValues {
    athletes: AthleteTeamMember[] | undefined;
    coaches: TeamAthlete[] | undefined;
    loading: boolean;
    parents: TeamAthlete[] | undefined;
    refreshMembers: () => void;
    refreshTeams: () => void;
    role: TEAM_ROLE | undefined;
    selectedTeam: TeamAthlete | undefined;
    setSelectedTeam: (team: TeamAthlete) => void;
    stripePaymentUser: { stripeId: string; userId: string } | null;
    stripeState: StripeAccountContextValues | null;
    teams: TeamAthlete[] | undefined;
    teamMembers: TeamAthlete[] | undefined;
    userMembershipInfo: TeamAthlete | undefined;
}

export const TeamContext = createContext<TeamContextValues>({
    athletes: undefined,
    coaches: undefined,
    loading: true,
    parents: undefined,
    refreshTeams: () => {},
    refreshMembers: () => {},
    role: undefined,
    selectedTeam: undefined,
    setSelectedTeam: () => {},
    stripePaymentUser: null,
    stripeState: null,
    teams: undefined,
    teamMembers: undefined,
    userMembershipInfo: undefined,
});

// Access team context values and functions
const useTeams = () => {
    const ctx = useContext(TeamContext);

    if (!ctx) console.error('useTeams called outside of TeamProvider Context');

    return ctx;
};

export default useTeams;
